module.exports = __webpack_public_path__ + "static/img/A95.ea3ae1b6.jpg";